<template>
  <v-flex>
    <v-layout row class="content-header">
      <v-flex md5 class="content-title">
        <h2>Boletos</h2>
        <h4>Consulte e faça download de boletos.</h4>
      </v-flex>
      <v-flex md3>
        <v-text-field
          v-model="search"
          label="Pesquisa"
          placeholder="CPF, CNPJ, Apólice..."
          outlined
          class="input-pesquisa"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        &nbsp;<v-btn color="info" @click="pesquisar()"
          ><v-icon>mdi-magnify</v-icon></v-btn
        >
        &nbsp;&nbsp;<v-btn color="info" @click="requestBoletos()"
          >Listar Boletos Disponíveis</v-btn
        >
      </v-flex>
      <v-flex md12>
        <div class="line"></div>
      </v-flex>
    </v-layout>
    <v-layout row class="content-body overflow-y-auto">
      <v-flex md12>
        <v-data-table
          :headers="headers"
          :items="boletos"
          :items-per-page="topItems"
          :loading="loading"
          :search="search"
          loading-text="Carregando... Por favor aguarde."
          :no-data-text="noDataText"
          no-results-text="Nenhuma informação encontrada"
          :sort-by="['dataVencimento']"
          :sort-desc="[true]"
          class=""
        >
          <template v-slot:item.valorDecimalBoleto="{ item }">
            {{ FormatarValorMonetario(item.valorDecimalBoleto) }}
          </template>
          <template v-slot:item.competencia="{ item }" class="text-center">
            <span v-if="item.dataFimVigencia == null">-</span>
            <span v-if="item.dataFimVigencia != null">
              {{
                ("" + item.competencia + "").substring(0, 4) +
                  "/" +
                  ("" + item.competencia + "").substring(4, 6)
              }}
            </span>
          </template>
          <template v-slot:item.razaoSocial="{ item }" class="text-center">
            {{ item.razaoSocial }}
          </template>
          <template v-slot:item.vencimento="{ item }">
            <span class="alert" v-if="item.status == 0">{{
              item.vencimento
            }}</span>
            <span class="alert alert-warning" v-if="item.status == 1">{{
              item.vencimento
            }}</span>
            <span class="alert alert-danger" v-if="item.status == 2">{{
              item.vencimento
            }}</span>
          </template>
          <template v-slot:item.dataVencimento="{ item }">
            <v-chip
              class="ma-2"
              :color="verificaStatus(item)"
              text-color="white"
            >
              {{ FormatarData(item.dataVencimento) }}
            </v-chip>
          </template>
          <template v-slot:item.cpfCnpj="{ item }">
            {{ formatarCpfCnpj(item.cpfCnpj) }}
          </template>
          <template v-slot:item.anexo="{ item }">
            <img
              class="hover"
              src="/img/icon-pdf.png"
              @click="gerarBoleto(item)"
            />
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-overlay :value="fullLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-flex>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import Helpers from "@/utilities/Helpers";

export default {
  mixins: [Helpers],
  data() {
    return {
      search: "",
      baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
      termoPesquisa: "",
      loading: false,
      fullLoading: false,
      topItems: 10,
      offset: 1,
      headers: [
        { text: "Prêmio(R$)", value: "valorDecimalBoleto", sortable: true },
        { text: "Competência", value: "competencia", sortable: true },
        { text: "Apólice", value: "apolice", sortable: true },
        {
          text: "Apólice sem ponto",
          value: "ApoliceSemPonto",
          sortable: false,
          align: " d-none",
        },
        { text: "Fatura", value: "fatura", sortable: true },
        {
          text: "Fatura sem ponto",
          value: "FaturaSemPonto",
          sortable: false,
          align: " d-none",
        },
        { text: "Estipulante/Segurado", value: "razaoSocial", sortable: true },
        { text: "CNPJ/CPF", value: "cpfCnpj", sortable: true },
        {
          text: "CNPJ/CPF com ponto",
          value: "cpfCnpjComPonto",
          sortable: false,
          align: " d-none",
        },
        { text: "NR SUB", value: "numeroSubEstipulante", sortable: true },
        { text: "Vencimento", value: "dataVencimento", sortable: true },
        { text: "Download", value: "anexo", sortable: false },

        //{text: "CNPJ/CPF com ponto", value: "CnpjCpfComPonto", sortable: false, align: ' d-none'},
      ],
      boletos: [],
      noDataText: "Nenhuma informação pesquisada",
    };
  },
  methods: {
    requestBoletos() {
      this.loading = true;
      this.fullLoading = true;
      let codigoCorretor = this.usuario.codCorretor;

      let url = "Boleto/" + codigoCorretor;

      if (this.search != "") url += "/" + this.search.split("/").join("_");

      // Request boletos
      Vue.prototype.$httpPortal
        .get(url)
        .then((res) => {
          console.log(res.data);

          if (res.data.length == 0) {
            this.noDataText = "Nenhuma informação encontrada";
          }
          let dados = res.data;
          for (let item in dados) {
            //dados[item].dataVencimento = this.FormatarData(dados[item].dataVencimento);
            dados[item].ApoliceSemPonto = dados[item].apolice
              .split(".")
              .join("")
              .split("-")
              .join("");
            dados[item].FaturaSemPonto = dados[item].fatura
              .split(".")
              .join("")
              .split("-")
              .join("");
            dados[item].cpfCnpjComPonto = this.formatarCpfCnpj(
              dados[item].cpfCnpj
            );
          }
          this.boletos = dados;
          //this.search = "";
          this.loading = false;
          this.fullLoading = false;
        })
        .catch((ex) => {
          console.log(ex);
          this.noDataText = "Nenhuma informação encontrada";
          this.loading = false;
          this.fullLoading = false;
        });
    },
    pesquisar() {
      this.requestBoletos();
    },
    gerarBoleto(value) {
      //this.fullLoading = true;
      let url =
        this.baseURL +
        "Emissao/Boleto/" +
        this.usuario.codCorretor +
        "/" +
        value.nossoNumero;

      // se for I4PRO pega o link
      if (value.tpSistema == "I4PRO") url = value.linkBoleto;

      window.open(url, "_blank");
      
    },
    verificaStatus(value) {
      let dataAtual = new Date();

      if (value.situacaoPagamento == "ABE") return "green";

      return "orange";
    },
    FormatarValorMonetario(valor) {
      return valor.toLocaleString("pt-br", { minimumFractionDigits: 2 });
    },
  },
  computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo" }),
  },
  filters: {
    formatDateBR(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
  },
  mounted() {
    //this.requestBoletos()
  },
};
</script>
